import { IconComponentProps } from '../IconTypes';

const ScoreCircleQuarter = ({ className }: IconComponentProps) => (
  <svg
    className={className}
    fill="currentColor"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.6257 6.99992C12.6257 10.1065 10.1073 12.6249 7.00065 12.6249C3.89405 12.6249 1.37565 10.1065 1.37565 6.99992C1.37565 3.89332 3.89405 1.37492 7.00065 1.37492V6.99992H12.6257ZM7.00065 13.6666C10.6825 13.6666 13.6673 10.6818 13.6673 6.99992C13.6673 3.31802 10.6825 0.333252 7.00065 0.333252C3.31875 0.333252 0.333984 3.31802 0.333984 6.99992C0.333984 10.6818 3.31875 13.6666 7.00065 13.6666Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default ScoreCircleQuarter;
